
import ScrollPanel from 'primevue/scrollpanel'
import ViewportObserver from 'utils/viewport-observer'

const DURATION = 400

const SCROLL_TIMELINE = CSS.supports('animation-timeline: scroll()')

const __default__ = {
  components: {ScrollPanel},
  props: {
    smoothScroll: {type: Boolean, default: true},
    maxHeight: {type: String, default: 'unset'},
    observerThreshold: {type: [Number, Array], default: 0},
    fade: {type: Boolean, default: false},
    barXOffset: {type: String, default: '0.4rem'},
  },
  emits: ['scroll', 'wheel', 'scroll-end', 'scroll-end'],
  data() {
    return {
      raf_id: undefined,
      scrolling: false,
      viewport_observer: undefined,
    }
  },
  mounted() {
    const content = this.getContent()
    content.addEventListener('scroll', this.onScroll)
    content.addEventListener('wheel', this.onWheel)
    this.viewport_observer = new ViewportObserver({root: content, threshold: this.observerThreshold})
    if (this.fade) this.updateFade()
  },
  beforeUnmount() {
    this.abortScrolling()
    const content = this.getContent()
    content.removeEventListener('scroll', this.onScroll)
    content.removeEventListener('wheel', this.onWheel)
    this.viewport_observer?.disconnect()
  },
  methods: {
    refresh(){
      this.$refs.panel.refresh()
    },
    getContent() {
      return this.$refs.panel.$el.querySelector('[data-pc-section="content"]')
    },

    getObserver(){
      return this.viewport_observer
    },
    maxTop() {
      const el = this.getContent()
      return el.scrollHeight - el.clientHeight
    },
    currTop() {
      const el = this.getContent()
      return el.scrollTop
    },

    checkBottom() {
      // Checking if we're already reach the bottom
      // Some of these properties are rounded, which means that the equality can fail 
      // in cases where scrollTop would have a decimal component or when the rounded values align poorly.
      const el = this.getContent()
      return Math.abs(el.scrollHeight - el.clientHeight - el.scrollTop) <= 1
    },

    scrollTop(top, {smooth, check_bottom = true, follow_end = true} = {}) {
      const el = this.getContent()
      const maxTop = this.maxTop()
      const targetTop = top === -1 ? maxTop : (top > maxTop ? maxTop : top)

      if (check_bottom && this.checkBottom()) {
        return
      }

      if (!smooth) {
        this.$refs.panel.scrollTop(targetTop)
        return 
      }

      // Custom smooth scrolling below is written and tested to scroll to the end
      // if (maxTop !== targetTop) {
      //   throw new Error('Not implemented')
      // }

      // do not allow to enter into scroll while we're scrolling
      if (this.scrolling) {
        return
      }

      
      this.scrollTo = targetTop
      const startTime = new Date().getTime()

      
      const easeInOutQuart = (time, from, distance, duration) => {
        if ((time /= duration / 2) < 1) return distance / 2 * time * time * time * time + from
        return -distance / 2 * ((time -= 2) * time * time * time - 2) + from
      }

      // Quadratic in-ease-out
      // const easeInOutQuad = (time, from, distance, duration) => {
      //   time /= duration / 2
      //   if (time < 1) return distance / 2 * time * time + from
      //   time--
      //   return -distance / 2 * (time * (time - 2) - 1) + from
      // }
      const startTop = el.scrollTop
      this.scrolling = true 
      
      const animator = () => {
        const time = new Date().getTime() - startTime
        const newTop = easeInOutQuart(time, startTop, targetTop - startTop, DURATION)
        el.scrollTo({top: newTop, behavior: 'instant'})
        if (time >= DURATION) {
          // since easing formula is based on floats we might be not at the end by 1 pixel
          // ensure that we're really at the target
          el.scrollTo({top: targetTop, behavior: 'instant'})
          this.scrolling = false
          // continue to the end if any content was added while were scrolling 
          if (top === -1 && follow_end) {
            this.scrollToEnd(smooth)
          }
          this.$emit('scroll-end')
        } else {
          this.raf_id = requestAnimationFrame(animator)
        }
      }

      this.raf_id = requestAnimationFrame(animator)
    },
    scrollToEnd(smooth, {follow_end = true} = {}) {
      this.scrollTop(-1, {smooth, follow_end})
    },
    scrollToTop(smooth){
      this.scrollTop(0, {smooth})
    },
    onScroll(ev) {
      if (this.fade) this.updateFade()
      this.$emit('scroll', ev)
    },
    onWheel(ev){
      this.$emit('wheel', ev)
    },
    abortScrolling(){
      if (this.raf_id) {
        cancelAnimationFrame(this.raf_id)
        this.raf_id = undefined
      }
      this.scrolling = false
    },

    updateFade() {
      // fallback for browsers that don't support scroll-timeline
      // we use this property for fade effect while scrolling
      if (SCROLL_TIMELINE) return
      const el = this.getContent()
      const max = el.scrollHeight - el.clientHeight
      const top = el.scrollTop

      el.style.setProperty('--top-fade', top > 0 ? '3rem' : '0')
      el.style.setProperty(
        '--bottom-fade',
        top < max ? '3rem' : '0'
      )
    },

    hasVerticalScroll() {
      const el = this.getContent()
      return el.scrollHeight > el.clientHeight
    }

  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "d70bec7a-maxHeight": (_ctx.maxHeight),
  "d70bec7a-barXOffset": (_ctx.barXOffset)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__